import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Link } from '@mui/material';

const Footer = ({ className, sx, ...rest }) => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      className={className}
      sx={{
        px: 3,
        pt: 0,
        pb: 1.5,
        alignItems:'center',
        display:'flex',
        justifyContent:'center',
        ...sx
      }}
      {...rest}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          fontSize: 12,
          lineHeight: 1.5
        }}
      >
        
        © {currentYear}{' '} EHRZip
        {/* <Link
          href="https://elcaminomed.com/"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          color="inherit"
        >
          EHRZip
        </Link> */}
        . All rights reserved.
      </Typography>
    </Box>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
  sx: PropTypes.object
};

export default Footer;